module.exports = __webpack_public_path__ + "static/certificate12x-c91eda2212ec17a6e357f91a0e44e283.jpg";